var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddFaqIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.714,
    height: 27.707,
    viewBox: "0 0 27.714 27.707",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3472",
    "data-name": "Group 3472",
    transform: "translate(0.009 0.006)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_735",
    "data-name": "Path 735",
    d: "M23.648,23.648a13.857,13.857,0,1,0-19.6,0,13.857,13.857,0,0,0,19.6,0ZM5.029,5.029a12.475,12.475,0,1,1,0,17.642,12.475,12.475,0,0,1,0-17.642Z",
    fill: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_736",
    "data-name": "Path 736",
    d: "M160.9,167.941a1,1,0,0,0,.694-.287.983.983,0,0,0,.287-.694v-5.367h5.367a1,1,0,0,0,.694-.287.983.983,0,0,0,.287-.694.967.967,0,0,0-.973-.973h-5.367v-5.367a.973.973,0,1,0-1.946,0v5.367h-5.367a.973.973,0,1,0,0,1.946h5.367v5.367a.948.948,0,0,0,.957.989Z",
    transform: "translate(-147.047 -146.77)",
    fill: "#1c1c1c"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFaqIcon);
export default __webpack_public_path__ + "static/media/Add_faq_icon.a37f151405c5fb4bb517743434283bfb.svg";
export { ForwardRef as ReactComponent };